<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import ConnectorsAPI from 'dashboard/api/agents/connectors';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({ connectorId: { type: Number, required: true } });
const { t } = useI18n();
const orderNumber = ref('');
const phone = ref('');
const verified = ref(false);
const busy = ref(false);
const result = ref('');
const submit = async revoke => {
  busy.value = true;
  result.value = '';
  try {
    const payload = {
      order_number: orderNumber.value,
      phone: phone.value,
      verified: verified.value,
    };
    if (revoke) {
      await ConnectorsAPI.revokeMarketplaceOrder(props.connectorId, payload);
      result.value = t('MARKETPLACE_CONNECTOR.REVOKED');
    } else {
      const { data } = await ConnectorsAPI.verifyMarketplaceOrder(
        props.connectorId,
        payload
      );
      result.value = data.message;
    }
    verified.value = false;
  } catch (error) {
    result.value =
      error.response?.data?.error || t('AI_AGENTS.MESSAGES.UPDATE_ERROR');
  } finally {
    busy.value = false;
  }
};
</script>

<template>
  <div class="space-y-3 rounded-lg border border-n-weak p-3">
    <h4 class="text-sm font-semibold text-n-slate-12">
      {{ t('MARKETPLACE_CONNECTOR.VERIFY_TITLE') }}
    </h4>
    <p class="text-xs text-n-slate-11">
      {{ t('MARKETPLACE_CONNECTOR.VERIFY_HELP') }}
    </p>
    <label class="block text-sm text-n-slate-12">
      {{ t('MARKETPLACE_CONNECTOR.ORDER') }}
      <input
        v-model="orderNumber"
        inputmode="numeric"
        class="mt-1 w-full rounded-lg border border-n-weak bg-n-solid-1 p-2"
      />
    </label>
    <label class="block text-sm text-n-slate-12">
      {{ t('MARKETPLACE_CONNECTOR.PHONE') }}
      <input
        v-model="phone"
        type="tel"
        class="mt-1 w-full rounded-lg border border-n-weak bg-n-solid-1 p-2"
      />
    </label>
    <label class="flex items-start gap-2 text-sm text-n-slate-12">
      <input v-model="verified" type="checkbox" />{{
        t('MARKETPLACE_CONNECTOR.CONFIRM')
      }}
    </label>
    <div class="flex flex-wrap gap-2">
      <Button
        :label="t('MARKETPLACE_CONNECTOR.VERIFY')"
        :disabled="busy || !verified || !phone || !orderNumber"
        @click="submit(false)"
      />
      <Button
        :label="t('MARKETPLACE_CONNECTOR.REVOKE')"
        variant="outline"
        :disabled="busy || !phone || !orderNumber"
        @click="submit(true)"
      />
    </div>
    <p v-if="result" role="status" class="text-sm text-n-slate-11">
      {{ result }}
    </p>
  </div>
</template>
